import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom as _fvf } from 'rxjs';
import { IResponse } from '../interfaces/response.interface';

@Injectable({ providedIn: "root" })
export class AccountService {

  constructor(private http: HttpClient) { }


  async changeLanguage(lang: any) {
    return _fvf(this.http.put<IResponse<string>>('web/user/change-language', { lang }, { params: { isSilent: true } }));
  }


  /** Get */
  getCurrentLanguage() {
    return _fvf(this.http.get<IResponse<string>>(`user/current/language`));
  }


}
